import useDarkMode from 'use-dark-mode';
import { useEffect } from 'react';

export default function useLightMode() {
    // Prefixed to avoid collisions with other apps on the same origin in
    // dev. Must match the storageKey passed into useDarkMode below so the
    // two code paths read/write the same localStorage entry.
    const storageKey = 'marginpal-darkMode';

    const getInitialTheme = () => {
        const savedTheme = localStorage.getItem(storageKey);
        if (savedTheme === null) {
            localStorage.setItem(storageKey, false);
            return false;
        }
        return savedTheme === 'true';
    }

    const darkMode = useDarkMode(getInitialTheme(), { storageKey, classNameDark: 'dark-mode', classNameLight: 'light-mode' });
    const theme = darkMode.value ? 'dark-mode' : 'light-mode';

    // Bootstrap 5.3's built-in color-mode system looks at [data-bs-theme] on
    // <html>. Syncing it here means every Bootstrap-styled component (forms,
    // tables, buttons, cards, modals, dropdowns) themes automatically.
    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', darkMode.value ? 'dark' : 'light');
    }, [darkMode.value]);

    return { theme, toggleTheme: darkMode.toggle };
}